import TonalButton from '@/components/TonalButton';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';

const AddProofLinkButton = styled(TonalButton)(
  {
    marginRight: 8,
    height: 32,
  },
  addHighContrastStyles({
    height: 36,
  }),
);

export default AddProofLinkButton;
